import React from 'react';
import {
  Grid, Header, Label, List,
} from 'semantic-ui-react';
import History from './History';
import MixpanelTracker from '../../../utils/MixpanelTracker';

const hasProtocol = (url) => /^[a-z][a-z\d+\-.]*:\/\//i.test(url);

export const getPublicLinkHref = (url) => (hasProtocol(url) ? url : `https://${url}`);

export const getPublicLinkDomain = (url) => {
  try {
    return new URL(getPublicLinkHref(url)).hostname.replace(/^www\./, '');
  } catch {
    return url.replace(/^[a-z][a-z\d+\-.]*:\/\//i, '').replace(/^www\./, '').split('/')[0];
  }
};

const Content = ({ expert }) => {
  const uniqueTags = Array.from(new Set([...expert.medical_specialties, ...expert.functions,
    ...expert.technology_tags, expert.organization.type].filter((x) => x)));

  const trackLinkedInClick = (url) => {
    if (url.includes('linkedin.com')) {
      MixpanelTracker.trackClickLinkedInLink(expert);
    }
  };

  return (
    <Grid container stackable>
      <Grid.Column width={10} className="detail">
        <Grid container>
          <Grid.Row>
            <Grid.Column>
              <Header>{`About ${expert.fullName}`}</Header>
              <div className="section">
                {expert.description}
              </div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Header>Recent Experiences</Header>
              <List bulleted>
                {expert.employmentHistory.map((employment) => (
                  <List.Item key={employment.id}>
                    {`${employment.isCurrent ? '(current) ' : ''}${employment.title}, ${employment.organization.name}`}
                  </List.Item>
                ))}
              </List>
            </Grid.Column>
          </Grid.Row>
          {expert.publicLinks.length > 0 && (
            <Grid.Row>
              <Grid.Column>
                <Header>URLs</Header>
                <List bulleted>
                  {expert.publicLinks.map((url) => (
                    <List.Item
                      key={url}
                      as="a"
                      href={getPublicLinkHref(url)}
                      target="_blank"
                      rel="noreferrer"
                      onClick={() => trackLinkedInClick(url)}
                    >
                      {getPublicLinkDomain(url)}
                    </List.Item>
                  ))}
                </List>
              </Grid.Column>
            </Grid.Row>
          )}
          {expert.credentials.length > 0 && (
          <Grid.Row>
            <Grid.Column>
              <Header>Credentials</Header>
              <List className="tags-section">
                {expert.credentials.map((t) => <Label key={t} size="small" basic>{t}</Label>)}
              </List>
            </Grid.Column>
          </Grid.Row>
          )}
          <Grid.Row>
            <Grid.Column>
              <Header>Expert Tags</Header>
              {uniqueTags.length > 0 && (
                <List className="tags-section">
                  {uniqueTags.map((t) => <Label key={t} size="small">{t}</Label>)}
                </List>
              )}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Column>
      <Grid.Column width={6} className="history">
        <Grid container>
          <Grid.Row>
            <Grid.Column>
              <Header>Projects with my team</Header>
              <History expertId={expert.id} />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Column>
    </Grid>
  );
};

export default Content;
